import Mention from '../../Mention';

class EmbeddedMention extends Mention {
  protected override defaultNewTab = true;
}

export default EmbeddedMention;
